<app-multimedia-tile-box>
  @if (withClickEvent()) {
    <div
      (click)="handleClickEvent()"
      role="button">
      <ng-container [ngTemplateOutlet]="contentTemplateRef" />
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="contentTemplateRef" />
  }

  @if (withRemoveEvent()) {
    <app-multimedia-tile-box-remove-button
      (removeClickEvent)="handleRemoveClickEvent()" />
  }
</app-multimedia-tile-box>

<ng-template #contentTemplateRef>
  <div class="absolute inset-0 flex justify-center">
    <app-image-thumbnail
      class="my-auto"
      size="full">
      <img
        [alt]="alt()"
        [class]="previewFillingCssClass()"
        [fill]="true"
        [ngSrc]="url()"
        loading="lazy" />
    </app-image-thumbnail>
  </div>
</ng-template>
